import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { Profile, StudentNewComm } from "../Page/StudentNewComming";

export function RouteStudentNewComming({ student }) {
  const COMPONENT_MAP = {
    StudentNewComm: StudentNewComm,
    Profile: Profile
  };
  return (
    <Suspense fallback={<h3>Loading..</h3>}>
      <Route
        path="/"
        exact
        render={(routeProps) => (
          <COMPONENT_MAP.Profile {...routeProps} student={student} />
        )}
      />
      <Route
        path="/dashboard"
        exact
        render={(routeProps) => (
          <COMPONENT_MAP.Profile {...routeProps} student={student} />
        )}
      />
      <Route
        path="/profile"
        render={(routeProps) => (
          <COMPONENT_MAP.Profile {...routeProps} student={student} />
        )}
      />
    </Suspense>
  );
}
